import { api } from './_init'

const isHttpSuccess = (status) => status >= 200 && status < 300

export const sendGenerateImagesRequest = async (body) => {
  try {
    const response = await api.post('/integrations/openai/generate_images', {
      ...body,
    })

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
    }
  }
}

export const fetchGeneratedImages = async (eventId, tc, tcRunId) => {
  try { 
    const response = await api.get(`/integrations/openai/generated_images?eid=${eventId}&tc=${tc}&tc_run_id=${tcRunId}`)

    if (response.status !== 200) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
      status: error.response?.status,
    }
  }
}

export const postGeneratedImages = async (body) => {
  try {
    const response = await api.post('/integrations/openai/cocreate_images', {
      ...body,
    })

    if (!isHttpSuccess(response.status)) {
      throw new Error()
    }

    return {
      success: true,
      data: response.data,
    }

  } catch (error) {
    return {
      success: false,
      error: error.message,
      status: error.response?.status,
    }
  }
}